// SPDX-License-Identifier: GPL-3.0-or-later

export const STATUSES = [
  'Saved',
  'Applied',
  'Interview',
  'Rejected',
  'Offer',
  'Discarded',
  'Closed',
  'Filtered',
] as const;
export type Status = typeof STATUSES[number];

export type ApplyType = 'Easy Apply' | 'External Link' | string;

export interface GenRef {
  pdfRelPath?: string;
  texRelPath?: string;
  generatedAt: string;
}

export interface Application {
  id: string;
  jobTitle: string;
  companyName: string;
  jobUrl: string;
  applyType: ApplyType;
  status: Status;
  savedAt: string;
  folderRelPath: string;
  notes?: string;          // freeform notes; auto-screen writes the rejection reason here
  generated?: {
    cv?: GenRef;
    cover?: GenRef;
    interview?: GenRef;
  };
}

export interface ModelChoice {
  provider: string;
  id: string;
}

export interface ManifestConfig {
  cvPatterns: string[];
  motivationPatterns: string[];
  generateOnSave: 'auto' | 'manual';
  quickModel?: ModelChoice;
  inDepthModel?: ModelChoice;
}

export interface Manifest {
  schemaVersion: 2;
  applications: Application[];
  config: ManifestConfig;
}

export const DEFAULT_CONFIG: ManifestConfig = {
  cvPatterns: ['*CV*', '*Lebenslauf*', '*Resume*'],
  motivationPatterns: ['*Motivation*', '*Cover*', '*Anschreiben*'],
  generateOnSave: 'manual',
};
